import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5efb8146 = () => interopDefault(import('../pages/cart.vue' /* webpackChunkName: "pages/cart" */))
const _d0a0922c = () => interopDefault(import('../pages/favorites.vue' /* webpackChunkName: "pages/favorites" */))
const _28542532 = () => interopDefault(import('../pages/history.vue' /* webpackChunkName: "pages/history" */))
const _327537dc = () => interopDefault(import('../pages/idlink.vue' /* webpackChunkName: "pages/idlink" */))
const _5863d0a5 = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _2654ec60 = () => interopDefault(import('../pages/settings.vue' /* webpackChunkName: "pages/settings" */))
const _67620d92 = () => interopDefault(import('../pages/template.vue' /* webpackChunkName: "pages/template" */))
const _0591b565 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/cart",
    component: _5efb8146,
    name: "cart"
  }, {
    path: "/favorites",
    component: _d0a0922c,
    name: "favorites"
  }, {
    path: "/history",
    component: _28542532,
    name: "history"
  }, {
    path: "/idlink",
    component: _327537dc,
    name: "idlink"
  }, {
    path: "/search",
    component: _5863d0a5,
    name: "search"
  }, {
    path: "/settings",
    component: _2654ec60,
    name: "settings"
  }, {
    path: "/template",
    component: _67620d92,
    name: "template"
  }, {
    path: "/",
    component: _0591b565,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
